export type FeatureFlagName =
  | 'dashboard'
  | 'dashboardV2'
  | 'tenantsIncome'
  | 'tenantsIncomeV2'
  | 'settingsCrmV2'
  | 'settingsCrmV2.companySettings'
  | 'agentReports'
  | 'companySettings'
  | 'globalParkSettingsV2'
  | 'globalParkSettingsV2.parkSettings'
  | 'globalParkSettingsV2.retentions'
  | 'accounting'
  | 'driverOutflow'
  | 'schedule'
  | 'scheduleV2'
  | 'reportConsolidated'
  | 'reportTechInspectionReport'
  | 'carReport'
  | 'localCarPark'
  | 'debtorsByBalances'
  | 'driverDepositDebts'
  | 'driverSurcharge'
  | 'driverGiveOutAmount'
  | 'registryWithdraw'
  | 'cashRegister'
  | 'openTransactionsDebts'
  | 'investors'
  | 'techInspectionRequests'
  | 'techInspectionRepairs'
  | 'techInspectionHistory'
  | 'partsTransferHistoryList'
  | 'partsOrdersTable'
  | 'partsProvider'
  | 'partsStorage'
  | 'partsCategories'
  | 'parts'
  | 'partsItems'
  | 'partsTransferRequests'
  | 'partsTransferRequests'
  | 'partsDecommission'
  | 'partsDecommission'
  | 'partsDecommissionMovement'
  | 'partsDecommissionMovement'
  | 'workRulesSettings'
  | 'edmSettings'
  | 'techInspectionSettings'
  | 'crmKeysSettings'
  | 'crmKeysSettings.mozen'
  | 'crmKeysSettings.yandex'
  | 'crmKeysSettings.myavo'
  | 'crmKeysSettings.atimo'
  | 'crmKeysSettings.wialon'
  | 'crmKeysSettings.drivematics'
  | 'tenantsInfo'
  | 'tenantsInfo.driverToggle'
  | 'tenantsInfo.dropBalances'
  | 'tenantsInfo.driverSums'
  | 'tenantsInfo.statusColumn'
  | 'tenantsInfo.balanceColumn'
  | 'tenantsInfo.depositColumn'
  | 'tenantsInfo.depositHistoryButton'
  | 'tenantsInfo.balanceHistoryButton'
  | 'tenantsInfo.driverOpenTransactions'
  | 'tenantsInfo.balanceTaxometer'
  | 'carpark'
  | 'carpark.carsToggle'
  | 'carpark.driversToggle'
  | 'carpark.photoControlButton'
  | 'carpark.conditionsButton'
  | 'carpark.returnToLineButton'
  | 'carpark.editing.checkbox'
  | 'carpark.details.carUpload'
  | 'carpark.details.park'
  | 'carpark.details.history'
  | 'carpark.details.history'
  | 'carpark.details.carConditionsButton'
  | 'carpark.details.techInspectionButton'
  | 'fines'
  | 'finesHistory'
  | 'finesArchive'
  | 'parkTabs'
  | 'contracts'
  | 'offer'
  | 'instantPayment'
  | 'driversOffer'
  | 'maintenanceRepair'
  | 'newTenantsTable'
  | 'carFund'
  | 'rentalPayment'
  | 'admSettings'
  | 'verificationDriver'
  | 'fiscalReceipts'
  | 'fiscalReceiptsGeneration'
  | 'fiscalReceiptsSettings'
  | 'transactionReport'
  | 'notifySettings'
  | 'notify'
  | 'driverBalanceChanges'
  | 'driverGrades'

export type FeatureFlags = Record<FeatureFlagName, boolean>

export const defaultFlags: FeatureFlags = {
  dashboard: false,
  dashboardV2: true,
  tenantsIncome: true,
  tenantsIncomeV2: true,
  settingsCrmV2: true,
  'settingsCrmV2.companySettings': true,
  agentReports: true,
  companySettings: true,
  globalParkSettingsV2: true,
  'globalParkSettingsV2.parkSettings': true,
  'globalParkSettingsV2.retentions': true,
  accounting: true,
  driverOutflow: true,
  schedule: true,
  scheduleV2: true,
  reportConsolidated: true,
  reportTechInspectionReport: true,
  carReport: true,
  localCarPark: true,
  debtorsByBalances: true,
  driverDepositDebts: true,
  driverSurcharge: true,
  driverGiveOutAmount: true,
  registryWithdraw: true,
  cashRegister: true,
  openTransactionsDebts: true,
  investors: true,
  techInspectionRequests: true,
  techInspectionRepairs: true,
  techInspectionHistory: true,
  partsTransferHistoryList: true,
  partsOrdersTable: true,
  partsProvider: true,
  partsStorage: true,
  partsCategories: true,
  parts: true,
  partsItems: true,
  partsTransferRequests: true,
  partsDecommission: true,
  partsDecommissionMovement: true,
  workRulesSettings: true,
  edmSettings: true,
  techInspectionSettings: true,
  crmKeysSettings: true,
  'crmKeysSettings.mozen': true,
  'crmKeysSettings.yandex': true,
  'crmKeysSettings.myavo': true,
  'crmKeysSettings.atimo': true,
  'crmKeysSettings.wialon': true,
  'crmKeysSettings.drivematics': true,
  tenantsInfo: true,
  'tenantsInfo.driverToggle': true,
  'tenantsInfo.dropBalances': true,
  'tenantsInfo.driverSums': true,
  'tenantsInfo.statusColumn': true,
  'tenantsInfo.balanceColumn': true,
  'tenantsInfo.balanceTaxometer': true,
  'tenantsInfo.depositColumn': true,
  'tenantsInfo.depositHistoryButton': true,
  'tenantsInfo.balanceHistoryButton': true,
  'tenantsInfo.driverOpenTransactions': true,
  carpark: true,
  'carpark.carsToggle': true,
  'carpark.driversToggle': true,
  'carpark.photoControlButton': true,
  'carpark.conditionsButton': true,
  'carpark.returnToLineButton': true,
  'carpark.editing.checkbox': true,
  'carpark.details.carUpload': true,
  'carpark.details.park': true,
  'carpark.details.history': true,
  'carpark.details.carConditionsButton': true,
  'carpark.details.techInspectionButton': true,
  fines: true,
  finesHistory: true,
  finesArchive: true,
  parkTabs: true,
  contracts: true,
  offer: true,
  instantPayment: true,
  driversOffer: true,
  maintenanceRepair: true,
  newTenantsTable: true,
  carFund: true,
  rentalPayment: true,
  admSettings: true,
  verificationDriver: true,
  fiscalReceipts: true,
  fiscalReceiptsGeneration: true,
  fiscalReceiptsSettings: true,
  transactionReport: true,
  notifySettings: true,
  notify: true,
  driverBalanceChanges: true,
  driverGrades: true,
}

export const liteVersionFlags: FeatureFlags = {
  dashboard: false,
  dashboardV2: false,
  tenantsIncome: false,
  tenantsIncomeV2: false,
  settingsCrmV2: true,
  'settingsCrmV2.companySettings': true,
  agentReports: true,
  companySettings: true,
  globalParkSettingsV2: true,
  'globalParkSettingsV2.parkSettings': false,
  'globalParkSettingsV2.retentions': false,
  accounting: true,
  driverOutflow: false,
  schedule: false,
  scheduleV2: false,
  reportConsolidated: false,
  reportTechInspectionReport: false,
  carReport: false,
  localCarPark: false,
  debtorsByBalances: false,
  driverDepositDebts: false,
  driverSurcharge: false,
  driverGiveOutAmount: false,
  registryWithdraw: false,
  cashRegister: false,
  openTransactionsDebts: false,
  investors: false,
  techInspectionRequests: false,
  techInspectionRepairs: false,
  techInspectionHistory: false,
  partsTransferHistoryList: false,
  partsOrdersTable: false,
  partsProvider: false,
  partsStorage: false,
  partsCategories: false,
  parts: false,
  partsItems: false,
  partsTransferRequests: false,
  partsDecommission: false,
  partsDecommissionMovement: false,
  workRulesSettings: false,
  edmSettings: false,
  techInspectionSettings: false,
  crmKeysSettings: true,
  'crmKeysSettings.mozen': false,
  'crmKeysSettings.yandex': true,
  'crmKeysSettings.myavo': false,
  'crmKeysSettings.atimo': true,
  'crmKeysSettings.wialon': false,
  'crmKeysSettings.drivematics': false,
  tenantsInfo: true,
  'tenantsInfo.driverToggle': false,
  'tenantsInfo.dropBalances': false,
  'tenantsInfo.driverSums': false,
  'tenantsInfo.statusColumn': false,
  'tenantsInfo.balanceColumn': false,
  'tenantsInfo.balanceTaxometer': true,
  'tenantsInfo.depositColumn': false,
  'tenantsInfo.depositHistoryButton': false,
  'tenantsInfo.balanceHistoryButton': false,
  'tenantsInfo.driverOpenTransactions': false,
  carpark: true,
  'carpark.carsToggle': false,
  'carpark.driversToggle': false,
  'carpark.photoControlButton': false,
  'carpark.conditionsButton': false,
  'carpark.returnToLineButton': false,
  'carpark.editing.checkbox': false,
  'carpark.details.carUpload': false,
  'carpark.details.park': false,
  'carpark.details.history': false,
  'carpark.details.carConditionsButton': false,
  'carpark.details.techInspectionButton': false,
  fines: false,
  finesHistory: false,
  finesArchive: false,
  parkTabs: false,
  contracts: false,
  offer: false,
  instantPayment: false,
  verificationDriver: false,
  driversOffer: true,
  maintenanceRepair: true,
  newTenantsTable: false,
  carFund: false,
  rentalPayment: false,
  admSettings: true,
  fiscalReceipts: true,
  fiscalReceiptsGeneration: true,
  fiscalReceiptsSettings: true,
  transactionReport: false,
  notifySettings: true,
  notify: true,
  driverBalanceChanges: false,
  driverGrades: false,
}
